module.exports = __webpack_public_path__ + "static/media/buzzer-small1.0dbbdde0.aac";